<template>
  <div class="home_box">
    <HomeHeader />
    <div style="height: 70px;"></div>
    <div class="main_body">
      <router-view></router-view>
    </div>
    <footerInfo />
  </div>
</template>

<script>
import HomeHeader from '@/pages/newPages/booking/components/HomeHeader'
import footerInfo from '../frame/footerInfo.vue';
export default {
  data () {
    return {

    }
  },
  components: {
    HomeHeader,
    footerInfo
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.home_box {
  padding: 0;
  margin: 0;
  min-height: 100vh;
  width: 100%;
}

.main_body {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/booking/home.vue